export default __webpack_public_path__ + "static/media/my-img.258b3998.png";